module.exports = __webpack_public_path__ + "static/img/Daily Life.ab397e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/Daily Life.jpg
// module id = pgUX
// module chunks = 1